import { gql } from "@apollo/client";

export const CREATE_CONTACT = gql`
  mutation CreateContactMutation($input: CreateContactInput!) {
    createContact(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_CONTACT = gql`
  mutation UpdateContactMutation($id: Int!, $input: UpdateContactInput!) {
    updateContact(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_CONTACT = gql`
  mutation RemoveContactMutation($id: Int!) {
    removeContact(id: $id) {
      ok
      error
    }
  }
`;

export const CONTACT = gql`
  query ContactQuery($id: Int!) {
    contact(id: $id) {
      ok
      error
      result {
        id
        firstname
        lastname
        email
        phone
        isPrimary
        active
        customer {
          id
          name
        }
      }
    }
  }
`;

export const CONTACTS = gql`
  query ContactsQuery($where: ContactsFiltersInput!) {
    contacts(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        firstname
        lastname
        isPrimary
        active
        customer {
          id
          name
        }
      }
    }
  }
`;
